var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-container',{staticClass:"mtb-3"},[_c('h2',{staticClass:"mainTitle"},[_vm._v("System Config")])]),_c('v-card',{staticClass:"addCardBorderColor",attrs:{"outlined":""}},[_c('SectionChatGateways')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }